import { CalendarDays, Clock } from 'lucide-react';

import { cn } from '@/utils';
import {
  getDateWithTimeZone,
  getTimeWithTimeZone
} from '@/helpers/dateHelpers';

import { Card, CardContent } from '@/components/ui/card';

import { useOfferingSessionObject } from '@/data/offeringSession';
import { useOfferingObject } from '@/data/offering';

const OfferingSession = ({
  offeringId,
  offeringSessionId,
  isSelected,
  onSelect
}) => {
  const offeringSession = useOfferingSessionObject(
    offeringId,
    offeringSessionId
  );

  const offering = useOfferingObject(offeringId);

  if (!offeringSession) {
    return null;
  }

  return (
    <Card
      onClick={onSelect}
      className={cn(
        { 'border-2 border-ring -m-[1px]': isSelected },
        'cursor-pointer'
      )}
    >
      <CardContent className="p-2">
        <div className="flex items-center space-x-2  text-muted-foreground">
          <CalendarDays className="w-4 h-4" />
          <span className="text-sm">
            {getDateWithTimeZone(
              offeringSession.startDateTime,
              offering.region.timeZone,
              'EEE, MMM d'
            )}
          </span>
        </div>
        <div className="flex items-center space-x-2  text-muted-foreground">
          <Clock className="w-4 h-4" />
          <span className="text-sm">
            {getTimeWithTimeZone(
              offeringSession.startDateTime,
              offering.region.timeZone
            )}
          </span>
        </div>
      </CardContent>
    </Card>
  );
};

export default OfferingSession;
